import { useState } from "react";
import { IError} from "../api/ApiErrors";


export interface ILoadingState{
    loading:boolean;
    error?:IError;
    
}

export default function useLoadingState($default:ILoadingState={loading:true}){
    
    
    const [loadingState, setLoadingState] = useState<ILoadingState>($default);   


    const setLoading = ($value:boolean)=>{
        const newState:ILoadingState = {...loadingState};
        newState.loading = $value;
        setLoadingState(newState);
    }
    const setError = ($value?:IError)=>{
        const newState:ILoadingState = {...loadingState};
        newState.error = $value;
        setLoadingState(newState);
    }
    const resetLoadingState = ()=>{
        const newState:ILoadingState = {loading:true, error:undefined};
        setLoadingState(newState);
    }


    return [loadingState, setLoading, setError, setLoadingState, resetLoadingState] as const;
    
}